import { useLocation, useNavigate } from 'react-router-dom';

export const useNavigateSearch = () => {
  const navigate = useNavigate();

  const { search } = useLocation();

  return (pathname: string) => navigate({ pathname, search: search });
};
